import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=495d3e19&"
import script from "./PasswordRecovery.ts?vue&type=script&lang=js&"
export * from "./PasswordRecovery.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports